import React, { useEffect, useState } from "react";
import { Form, Input, Button } from "antd";
import "./Mfauthentication.css";
import Index from "../Index";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MRFverifyActionHandler } from "../../Redux/Actions/common/MfaAuthentications";
import { notification } from "antd";
import VerificationInput from "react-verification-input";
const Mfauthentication = () => {
  const mainLogo = "/assets/QA_Logo.svg";
  const dispatch = useDispatch();
  let Navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const [errorMessage, setErrorMessage] = useState("");
  const [verificationValue, setVerificationValue] = useState("");
  const isMFAVerifyCode = useSelector(
    (state) => state?.MfaAuthenticationsData?.mfaVerifyCodeMessage
  );
  const handleVerificationChange = (value) => {
    if (/^\d*$/.test(value)) {
    setVerificationValue(value);
    }
    if (errorMessage) setErrorMessage("");
  };

  useEffect(() => {
    if (isMFAVerifyCode) {
      localStorage.setItem("token", isMFAVerifyCode.data.token);
      localStorage.setItem("refresh_token", isMFAVerifyCode.data.refresh_token);
      localStorage.setItem(
        "userDetails",
        JSON.stringify(isMFAVerifyCode.data.user)
      );
      setTimeout(() => {
        Navigate("/");
      }, 2000);
    }
  }, [isMFAVerifyCode]);
  const validateInput = () => {
    if (!verificationValue.trim()) {
      setErrorMessage("This field cannot be empty.");
      return false;
    }
    return true;
  };
  const onVerifyCodeFinish = () => {
    const isValid = validateInput();
    if (!isValid) return;
    const session = localStorage.getItem("session");
    const session_email = localStorage.getItem("session_email");
    const updatedValues = {
      session: session,
      challenge_name: "SOFTWARE_TOKEN_MFA",
      challenge_responses: {
        USERNAME: session_email,
        SOFTWARE_TOKEN_MFA_CODE: verificationValue,
      },
    };

    dispatch(MRFverifyActionHandler(updatedValues));
  };

  return (
    <>
      <div className="login-container">
        <Index />
        {contextHolder}
        <div className="login-main">
          <div className="login-div">
            <div className="center-img">
              <img src={mainLogo} alt="" className="centered-image" />
            </div>
            <p className="login_text">Multi Factor Authentication</p>
            {/* <Form
                            className='mfauthentication-form'
                            name='loginForm'
                            initialValues={{ code: '' }}
                            onFinish={onVerifyCodeFinish}>
                            <label>
                                Enter your verification code to continue.
                            </label>
                            <Form.Item
                                name='code'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your Code!',
                                    },
                                ]}>
                                <Input placeholder='Verification Code' />
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    type='primary'
                                    htmlType='submit'
                                    block
                                    className='submit_login-btn'>
                                    Verify and Login
                                </Button>
                            </Form.Item>
                        </Form> */}
            <Form
              id="verification"
              name="loginForm"
              initialValues={{ code: "" }}
              onFinish={onVerifyCodeFinish}
            >
              <div className="Verification_input">
                <label>Enter your verification code to continue.</label>
                <VerificationInput
                  validChars="0-9"
                  value={verificationValue}
                  onChange={handleVerificationChange}
                />
                {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
              </div>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  className="submit_verify-btn mfa-settings-marginTop-30"
                  // onClick={handleStatusUpdate}
                >
                  Verify and Login
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Mfauthentication;
